export const MuiContainer = {
  styleOverrides: {
    root: {
      marginTop: '6vh',
    },
  },
};
